// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"form-view_shadow__N6Dvz","form":"form-view_form__1lAdV"};